// extracted by mini-css-extract-plugin
export var assetsBox = "form-module--assetsBox--dd51b";
export var bordertop = "form-module--bordertop--23701";
export var centerLabel = "form-module--centerLabel--3b229";
export var checkbokItembox = "form-module--checkbokItembox--0ccfd";
export var content = "form-module--content--d7587";
export var currentPaper = "form-module--currentPaper--df47d";
export var downloadlink = "form-module--downloadlink--a5020";
export var downloadlinksingle = "form-module--downloadlinksingle--5518c";
export var error = "form-module--error--a9568";
export var errorwarn = "form-module--errorwarn--99054";
export var form = "form-module--form--91146";
export var formDownloads = "form-module--formDownloads--ac2ba";
export var hidden = "form-module--hidden--b9747";
export var item = "form-module--item--14edd";
export var leftLabel = "form-module--leftLabel--d35f8";
export var messageok = "form-module--messageok--2b21e";
export var progressBar = "form-module--progressBar--5bd61";
export var selectOthers = "form-module--selectOthers--f6d4c";
export var termsBox = "form-module--termsBox--4e612";